export default [

  // exemplo padrão
  // {
  //   header: 'Pages',
  //   icon: 'FileIcon',
  //   children: [
  //     {
  //       title: 'Home',
  //       route: 'home',
  //       icon: 'HomeIcon',
  //     },
  //     {
  //       title: 'Second Page',
  //       route: 'second-page',
  //       icon: 'FileIcon',
  //     },
  //   ],
  // },

  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  // {
  //   title: 'Cobrança',
  //   route: 'cobranca',
  //   icon: 'DollarSignIcon',
  // },
  {
    title: 'Relatório',
    route: 'ordem',
    icon: 'SearchIcon',
  },
  {
    title: 'Transferência',
    route: 'transferencia',
    icon: 'DollarSignIcon',
  },
  // {
  //   title: 'Usuarios',
  //   route: 'usuario',
  //   icon: 'UsersIcon',
  // },
  // {
  //   title: 'Relatório',
  //   route: 'relatorio',
  //   icon: 'ActivityIcon',
  // },
]
